export const SENT_INVITATION_REQUEST = "RECEIVED_INVITATION_REQUEST";
export const SENT_INVITATION_FAILURE = "RECEIVED_INVITATION_FAILURE";
export const RECEIVED_INVITATION_SUCCESS = "RECEIVED_INVITATION_SUCCESS";
export const FETCH_INVITATIONS_REQUEST = "FETCH_INVITATIONS_REQUEST";
export const FETCH_INVITATIONS_SUCCESS = "FETCH_INVITATIONS_SUCCESS";
export const FETCH_INVITATIONS_FAILURE = "FETCH_INVITATIONS_FAILURE";
export const ACCEPT_INVITATION_REQUEST = "ACCEPT_INVITATION_REQUEST";
export const ACCEPT_INVITATION_SUCCESS = "ACCEPT_INVITATION_SUCCESS";
export const ACCEPT_INVITATION_FAILURE = "ACCEPT_INVITATION_FAILURE";